// extracted by mini-css-extract-plugin
export default {"container":"MicrophoneAccessModal_container__GjgLk"};